import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        form: '=',
        privileges: '='
    },
    template: `
        <form-row error="vm.form.errors.privileges">
            <div class="well items">
                <ul class="privileges01">
                    <li ng-repeat="(key, value) in vm.privileges">
                        <label>
                            <input
                                type="checkbox"
                                ng-disabled="vm.form.model.type == vm.ROLE_TYPE_ENUM.KEYS.SYSTEM_ROLE"
                                ng-checked="vm.hasPrivilege(key)"
                                ng-click="vm.togglePrivilege(key)"
                            >
                            <span>{{ value }}</span>
                        </label>
                    </li>
                </ul>
                <form-row-error></form-row-error>
            </div>
        <form-row/>
    `
})
export default class {
    constructor (lodash, ROLE_TYPE_ENUM) {
        this.lodash = lodash;
        this.ROLE_TYPE_ENUM = ROLE_TYPE_ENUM;
    }

    hasPrivilege (key) {
        return this.lodash.includes(this.form.model.privileges, key);
    }

    togglePrivilege (key) {
        if (this.hasPrivilege(key)) {
            this.lodash.pull(this.form.model.privileges, key);
        }
        else {
            this.form.model.privileges.push(key);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/privilegesSelection/index.js